import { useCallback } from 'react'

import { DrawingParameterRectangle, DrawingType, PolygonSubtype } from '@editor/interfaces/drawing'
import { EditorPanelItem, ElementsPanelConfig } from '@editor/interfaces/editor'
import { removeDrawings } from '@editor/pages/projects/blueprint-editor/store/drawings'
import { getDrawingsOfType } from '@editor/services/Drawing'
import { RootState, useAppDispatch } from '@editor/store/app'
import { resetElement, setCurrentAnchorPosition } from '@editor/store/tool'
import { useSelector } from 'react-redux'

const useDrawingsPanel = (): ElementsPanelConfig => {
  // Store
  const dispatch = useAppDispatch()
  const drawings = useSelector((state: RootState) => state.blueprint.drawings.document.drawings)
  const workingElementId = useSelector((state: RootState) => state.toolUtil.core.workingElementId)

  return {
    getPanelItems: useCallback(
      (parent?: EditorPanelItem['item']): EditorPanelItem[] => {
        if (parent) return [] as EditorPanelItem[]

        const results: EditorPanelItem[] = getDrawingsOfType<DrawingParameterRectangle>(
          drawings,
          DrawingType.Polygon,
          [],
        )
          .filter((drawing) => drawing.drawing_parameters.subtype === PolygonSubtype.Rectangle)
          .map((item, index) => ({
            key: `tool-rectangle-drawing-${item.drawing_parameters.uuid}`,
            name: item.name || `矩形 ${index + 1}`,
            item,
            isWorking: item.drawing_parameters.uuid === workingElementId,
            onDelete: () => {
              dispatch(removeDrawings([item.drawing_parameters.uuid]))
              dispatch(resetElement(item.drawing_parameters.uuid))
              dispatch(setCurrentAnchorPosition(undefined))
            },
          }))

        return results
      },
      [drawings, workingElementId, dispatch],
    ),
  }
}

export default useDrawingsPanel
